import styled from 'styled-components'

const EditIconWrap = styled.button<{ wasEdited: boolean }>`
  appearance: none;
  border: none;
  background: transparent;
  margin: 0;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  z-index: 2;
  line-height: 0;
  box-sizing: border-box;

  & svg {
    pointer-events: none;
    display: block;
    ${({ wasEdited }) => wasEdited && 'height: 20px; width: 20px'};
  }
`
export { EditIconWrap }
